/**
 * Validation configuration for rate lookup
 * Keep this in sync with API: src/rates/validationConfig.ts
 */

export const validationConfig = {
  // Age ranges
  lifeInsuredAgeMin: 50,
  lifeInsuredAgeMax: 80,
  spouseAgeMin: 50,
  spouseAgeMax: 80,

  // Deferral period rules by investor type and date
  deferralPeriodMinExisting: [
    { date: '2026-01-19', min: 1 },
    { date: '2023-03-01', min: 3 },
  ],
  deferralPeriodMinNew: [{ date: '2023-03-01', min: 1 }],

  // Maximum age when Agile income can start
  ageAgileIncomeStartsMax: 100,

  // Date ranges
  investmentDateMin: '2023-03-01',

  // Feature availability dates
  disableOptionsPriorTo: '2023-11-24',
};

/**
 * Get minimum deferral period based on investment date and investor type
 */
export function getMinimumDeferralPeriod(
  investmentDate: string,
  investorType: 'new' | 'existing'
): number {
  const policyDate = new Date(investmentDate);

  const rules =
    investorType === 'new'
      ? validationConfig.deferralPeriodMinNew
      : validationConfig.deferralPeriodMinExisting;

  // Find the first entry where investmentDate is on or after the date
  for (const rule of rules) {
    if (policyDate >= new Date(rule.date)) {
      return rule.min;
    }
  }

  // Fallback to the last entry's min value
  return rules[rules.length - 1].min;
}

/**
 * Get maximum deferral period based on life insured age
 */
export function getMaximumDeferralPeriod(lifeInsuredAge: number): number {
  return validationConfig.ageAgileIncomeStartsMax - lifeInsuredAge;
}
